export default __webpack_public_path__ + "static/media/edit-new.ed252e46.svg";